/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */

export type EnumProfiloSelezionatoTipo =
  (typeof EnumProfiloSelezionatoTipo)[keyof typeof EnumProfiloSelezionatoTipo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumProfiloSelezionatoTipo = {
  PF: 'PF',
  PG: 'PG',
} as const;
